module.exports = __webpack_public_path__ + "img/flux360-Tutorial_scroll.f06527e9.svg";